module.exports = __webpack_public_path__ + "img/pdf-file-icon.be27ab55.svg";